import { BaseComponent, Component, Prop, Ref, SimpleEvent, Watch } from "@eastsideco/salvo-ts";
import { ThemeComponent } from "@/theme/ThemeComponent";

/**
 * Product Details
 */
@Component
export class ProductPrice extends ThemeComponent {

}
